const prefix = '/iro-templates';
const prefix2 = '/admin';

const TEMPLATES_LIST_TAG = `${prefix}`;
export const TEMPLATES_REQUEST_TAG = `${prefix2}/iro-template-requests`;
export default TEMPLATES_LIST_TAG;
